import styled from 'styled-components';
import { theme } from '@/components/features/theme/theme';

export const StyledVideoTour = styled.div`
    .video-tour-wrapper {
        border-radius: 4px;
        background: #152637;
        position: relative;
        padding: 30px;
        min-height: 200px;
        min-width: 270px;
        cursor: pointer;

        @media(min-width: 1366px) {
            min-height: 230px;
        }

        .content {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;

            svg {
                position: absolute;
                bottom: 30px;
                left: 30px;
                cursor: pointer;
                overflow: hidden;
                border-radius: 50%;
                border: 1px solid transparent;

                .cursor_hover {
                    transition: ${theme.transition};
                }
            }

            p {
                color: #FFF;
                font-size: 1rem;
                font-style: normal;
                font-weight: 400;
                line-height: 1.25rem;
            }
        }

        .img {
            position: absolute;
            right: -100px;
            top: -14px;

            @media(min-width: 1336px) {
                right: -120px;

                img {
                    min-height: 260px;
                }
            }
        }

        &:hover {
            svg {
                border-color: white;
            }

            .cursor_hover {
                r: 30px;
            }
        }
    }

    @media(max-width: 767px) {
        max-width: 75%;
    }
`;
